/* eslint-disable no-unused-vars */

import { formatDateTime } from '@gameday/common/formats'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import InputAdornment from '@material-ui/core/InputAdornment'
import InputBase from '@material-ui/core/InputBase'
import Popover from '@material-ui/core/Popover'
import { withStyles } from '@material-ui/core/styles'
import Search from '@material-ui/icons/Search'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import theme from '../../utils/theme'
import Spinner from '../LoadingIndicator/Spinner'

const styles = () => ({
  resultsWrap: {
    padding: '10px 15px',
  },
  searchIcon: {
    padding: '6px',
    color: theme.header.textColor,
  },
  searchInput: {
    minWidth: '500px',
    marginBottom: '10px',
    marginTop: '10px',
  },
  noDataFound: {
    fontSize: theme.typography.fontSizeSmaller,
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColoAlt})`,
  },
  inputRoot: {
    width: '100%',
    height: '36px',
    minWidth: '500px',
    marginBottom: '10px',
    marginTop: '10px',
    paddingRight: '4px',
    border: theme.borders.default,
    borderRadius: theme.borders.borderRadius,
  },
  input: {
    height: '34px',
    margin: '0 4px',
    padding: '0 0 0 0.625rem',
    fontSize: theme.typography.fontSizeSm,
    '&:focus-within': {
      borderColor: theme.inputField.inputBorderActive,
      fontWeight: theme.typography.fontWeightBold,
    },
  },
})
const searchTypes = {
  GS_ORG: 'GS_ORG',
  GS_MEMBER: 'GS_MEMBER',
  GS_PRODUCT: 'GS_PRODUCT',
}

class GlobalSearch extends Component {
  state = {
    anchorEl: null,
    noDataFound: false,
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isSearching === true) {
      this.setState({ noDataFound: false })
    }

    if (nextProps.resultsData !== this.props.resultsData && nextProps.isSearching === false) {
      const noDataFound =
        // biome-ignore lint/complexity/useOptionalChain: TODO
        (nextProps.resultsData.data.members && nextProps.resultsData.data.members.totalCount) * 1 +
          // biome-ignore lint/complexity/useOptionalChain: TODO
          (nextProps.resultsData.data.organisations && nextProps.resultsData.data.organisations.totalCount) * 1 +
          // biome-ignore lint/complexity/useOptionalChain: TODO
          (nextProps.resultsData.data.products && nextProps.resultsData.data.products.totalCount) * 1 ===
        0
      this.setState({ noDataFound })
    }
  }

  handleClick = event => {
    this.setState({
      anchorEl: event.currentTarget,
      noDataFound: false,
    })
  }

  handleClose = () => {
    const { onClose } = this.props

    this.setState({
      anchorEl: null,
    })

    onClose()
  }

  handleViewMore = field => {
    const { viewMore } = this.props

    viewMore(field)

    this.setState({
      anchorEl: null,
    })
  }

  render() {
    const {
      classes,
      isSearching,
      resultsData,
      searchAction,
      // biome-ignore lint/correctness/noUnusedVariables: TODO
      searchIconColor,
      searchHeading,
      saveChanges,
      anchorV,
      anchorH,
      transformV,
      transformH,
    } = this.props
    const { anchorEl, noDataFound } = this.state
    const open = Boolean(anchorEl)
    return (
      <Wrapper>
        <IconButton
          aria-owns={open ? 'simple-popper' : undefined}
          aria-haspopup="true"
          onClick={event => (saveChanges ? saveChanges(this.handleClick, { ...event }) : this.handleClick(event))}
          aria-label="Search"
          className={classes.searchIcon}
        >
          <Search />
        </IconButton>
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: anchorV,
            horizontal: anchorH,
          }}
          transformOrigin={{
            vertical: transformV,
            horizontal: transformH,
          }}
          className={classes.popover}
        >
          <div className={classes.resultsWrap}>
            <SearchHeading>{searchHeading}</SearchHeading>
            <InputBase
              classes={{
                root: classes.inputRoot,
                input: classes.input,
              }}
              onChange={searchAction}
              placeholder="Search"
              endAdornment={
                // biome-ignore lint/complexity/noUselessFragments: TODO
                <React.Fragment>
                  {isSearching && (
                    <InputAdornment position="end">
                      <Spinner searching />
                    </InputAdornment>
                  )}
                </React.Fragment>
              }
            />
            {resultsData.data.members && resultsData.data.members.totalCount !== 0 && (
              <React.Fragment>
                <ResultGroupHeading>
                  Members ({resultsData.data.members.totalCount > 5 ? '5+' : resultsData.data.members.totalCount})
                  {resultsData.data.members.totalCount > 5 && (
                    <ViewMore onClick={() => this.handleViewMore(searchTypes.GS_MEMBER)} color="primary">
                      (View)
                    </ViewMore>
                  )}
                </ResultGroupHeading>
                {resultsData.data.members.member.slice(0, 5).map(member => (
                  <ResultLink
                    to={`/memberships/memberdetails/${btoa(
                      JSON.stringify({
                        profileId: member.profileId,
                        returnUrl: null,
                      })
                    )}`}
                    key={member.profileId}
                    onClick={this.handleClose}
                  >
                    {`${member.name} (${formatDateTime({
                      isDateOnly: true,
                      value: member.birthdate,
                      inUTCTimezone: true,
                      style: 2,
                    })})`}
                  </ResultLink>
                ))}
              </React.Fragment>
            )}

            {resultsData.data.organisations && resultsData.data.organisations.totalCount !== 0 && (
              <React.Fragment>
                <ResultGroupHeading>
                  Organisations (
                  {resultsData.data.organisations.totalCount > 5 ? '5+' : resultsData.data.organisations.totalCount})
                  {resultsData.data.organisations.totalCount > 5 && (
                    <ViewMore onClick={() => this.handleViewMore(searchTypes.GS_ORG)} color="primary">
                      (View)
                    </ViewMore>
                  )}
                </ResultGroupHeading>
                {resultsData.data.organisations.organisation.slice(0, 5).map(org => (
                  <ResultLink to={`/organisation/details?orgId=${org.id}`} key={org.id} onClick={this.handleClose}>
                    {org.name}
                  </ResultLink>
                ))}
              </React.Fragment>
            )}
            {resultsData.data.products && resultsData.data.products.totalCount !== 0 && (
              <React.Fragment>
                <ResultGroupHeading>
                  Products ({resultsData.data.products.totalCount > 5 ? '5+' : resultsData.data.products.totalCount})
                  {resultsData.data.products.totalCount > 5 && (
                    <ViewMore onClick={() => this.handleViewMore(searchTypes.GS_PRODUCT)} color="primary">
                      (View)
                    </ViewMore>
                  )}
                </ResultGroupHeading>
                {resultsData.data.products.product.slice(0, 5).map(product => (
                  <ResultLink
                    to={`/productDetails/${btoa(
                      JSON.stringify({
                        productId: product.id,
                        returnUrl: null,
                      })
                    )}`}
                    key={product.id}
                    onClick={this.handleClose}
                  >
                    {product.name}
                  </ResultLink>
                ))}
              </React.Fragment>
            )}
            {noDataFound && anchorEl && <div className={classes.noDataFound}>No record found</div>}
          </div>
        </Popover>
      </Wrapper>
    )
  }
}

GlobalSearch.defaultProps = {
  resultsData: {
    data: {
      members: { totalCount: 0 },
      organisations: { totalCount: 0 },
      products: { totalCount: 0 },
    },
  },
  searchIconColor: 'default',
  anchorV: 'bottom',
  anchorH: 'center',
  transformV: 'top',
  transformH: 'center',
}

const Wrapper = styled.span`
  display: inline-block;
`

const SearchHeading = styled.h2`
  font-size: 1.125rem;
  font-weight: normal;
  margin: 0;
  color: #acacac;
`

const ResultGroupHeading = styled.h3`
  font-size: 0.8125rem;
  font-weight: normal;
  text-transform: uppercase;
  color: #4a4a4a;
  padding-bottom: 5px;
  margin: 10px 0 5px 0;
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const ResultLink = styled(Link)`
  display: block;
  font-size: 0.8125rem;
  font-weight: 600;
  color: ${`var(--gameday-body-headingColor, ${theme.body.headingColor})`};
  text-decoration: none;
  padding: 5px 0;
`

const ViewMore = styled(Button)`
  && {
    text-transform: uppercase;
    font-size: 0.8125rem;
    min-height: 26px;
    padding: 0;
    color: ${theme.palette.primary.main};
  }
`

const GlobalSearchStyled = withStyles(styles)(GlobalSearch)
GlobalSearchStyled.displayName = 'GlobalSearch'
export default GlobalSearchStyled
